import type { Routine, Step } from '../types';

/**
 * Whether a step is effectively suppressed — either its own configuration has
 * `suppressed: true`, or any of its ancestors does. Suppression is stored only
 * at the node it was toggled on; inherited suppression is deduced via this
 * helper so every caller sees the same rule.
 *
 * Use this anywhere you need to know "will this step run?" — execution
 * skipping, visual muting, disabled actions, variable-picker filtering, etc.
 *
 * Accepts just the `id` and `parentSteps` fields so it can be called with any
 * step-like object that carries the ancestor chain.
 */
export function isStepEffectivelySuppressed(
  step: Pick<Step.ConvertedSummary, 'id' | 'parentSteps'>,
  stepConfigurations: Routine.ConvertedResponse['stepConfigurations'],
): boolean {
  if (stepConfigurations[step.id]?.suppressed) return true;

  return (step.parentSteps ?? []).some(
    (parent) =>
      parent != null && (stepConfigurations[parent.id]?.suppressed ?? false),
  );
}
